module.exports = {
    "collectionLabel": `Empfehlungen`
};


//# sourceMappingURL=de-DE.main.js.map
